import { gql } from '../../../apollo/__generated__';

export const VALIDATOR_EVENT_USERS = gql(`
  query ValidatorEventUsers($eventId: ID!) {
    eventUsers(eventId: $eventId) {
      id
      email
      firstname
      nickname
      lastname
      studyTown
      hasCaution(eventId: $eventId)
      hasPaidTicket(eventId: $eventId)
      isHere(eventId: $eventId)
      isValidated(eventId: $eventId)
      arrivalDay(eventId: $eventId)
      numberOfDays(eventId: $eventId)
    }
  }
`);
